export default __webpack_public_path__ + "static/experienceImg3-39467f55247a764ff7cf4a5d67a7f80a.webp";